import React from "react";
import ReactQuill from "react-quill";
import { RichTextEditorBase } from "./RichTextEditorBase";
import 'react-quill/dist/quill.bubble.css';
import quill from './quill.css';
import { useColor } from "../hooks";

const EditorStyles = ({ isFocused }) => {
    const [unfocused, focused] = useColor("gray.300", "primary.500");
    
    return (
        <style className="css-styles">
            {
                `
                    .${quill.editor} {
                        border-bottom: 0;
                    }
                    .${quill.editor} .ql-editor {
                        border-bottom-color: ${unfocused};
                    }
                    .${quill.editor} .ql-editor[data-focusvisible-polyfill] {
                        border-bottom-color: ${focused};
                    }
                `
            }
        </style>
    )
}

export class RichTextEditor extends RichTextEditorBase {
    parentRef = React.createRef(null);
    render() {
        return (
            <div ref={this.parentRef}>
                <ReactQuill
                    theme="bubble"
                    readOnly={this.props.isReadonly}
                    ref={this._editor}
                    modules={this.state.modules}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    value={this.props.value}
                    bounds={this.parentRef.current}
                    className={quill.editor}
                    onChange={this.handleChange}
                />
                <EditorStyles isFocused={this.state.focused} />
            </div>
        )
    }
}